import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Layout from '../Layout/Layout';
import { useInHub } from '../../nav/useInHub';

export default function MoneyHome() {
  const { t } = useTranslation();
  const inHub = useInHub();
  const navigate = useNavigate();

  const tiles = [
    {
      i18n: 'nav.money_plan',
      icon: 'pi pi-id-card',
      desc: 'money.tiles.plan',
      onClick: () => navigate('/profile', { state: { activeTab: 'billing' } }),
    },
    { i18n: 'nav.money_earnings',    icon: 'pi pi-chart-line',   desc: 'money.tiles.earnings',    to: '/billing/ad-earnings' },
    { i18n: 'nav.money_ad_settings', icon: 'pi pi-cog',          desc: 'money.tiles.ad_settings', to: '/billing/ads-settings' },
    { i18n: 'nav.money_marketplace', icon: 'pi pi-shopping-cart',desc: 'money.tiles.marketplace', to: '/apps/ad-marketplace' },
  ];

  return (
    <Layout>
      <div className="container-fluid py-3">
        {!inHub && (<>
          <h2 className="pp-page-title mb-2">
            <i className="pi pi-wallet" /> {t('nav.money')}
          </h2>
          <p className="text-muted mb-4">{t('money.subtitle')}</p>
        </>)}
        <div className="row g-3">
          {tiles.map((tile) => {
            const inner = (
              <div className="pp-card p-4 h-100 d-flex flex-column gap-2 hover-lift">
                <span className="pp-empty-icon" style={{ width: 48, height: 48, fontSize: '1.3rem' }}>
                  <i className={tile.icon} />
                </span>
                <h5 className="mb-0 mt-2" style={{ color: 'var(--pp-text-primary)', fontWeight: 700 }}>
                  {t(tile.i18n)}
                </h5>
                <p className="mb-0 small text-muted">{t(tile.desc)}</p>
                <span className="small fw-semibold mt-auto" style={{ color: 'var(--pp-btn-honey)' }}>
                  {t('common.open')} <i className="pi pi-arrow-right" style={{ fontSize: '0.75rem' }} />
                </span>
              </div>
            );
            return (
              <div key={tile.i18n} className="col-12 col-md-6 col-xl-3">
                {tile.to ? (
                  <Link to={tile.to} className="text-decoration-none">{inner}</Link>
                ) : (
                  <a href="#" onClick={(e) => { e.preventDefault(); tile.onClick(); }} className="text-decoration-none">
                    {inner}
                  </a>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </Layout>
  );
}
